import { render } from "./results-report.vue?vue&type=template&id=72e3115e&scoped=true&ts=true"
import script from "./results-report.vue?vue&type=script&lang=ts"
export * from "./results-report.vue?vue&type=script&lang=ts"

import "./results-report.vue?vue&type=style&index=0&id=72e3115e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72e3115e"]])

export default __exports__